import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/blog/[id]/components/FAQ.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/app/[lang]/services/[id]/components/DynamicDesc.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/services/[id]/components/ImagesSectionLong.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/services/[id]/components/ImagesSerctionShort.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/services/[id]/components/Preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/SeeMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/ui/slider.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/link.js");
